'use client'

import { ISubLoadType, useAllLoadTypes } from '@repo/sdk'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@repo/ui'
import { cn } from '@repo/ui/lib'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { useState } from 'react'
import { Control } from 'react-hook-form'
import { z } from 'zod'

interface Props {
  className?: string
  control: Control<{ load_type_id: number }>
}

export const TrailerTypeSelect = ({ className, control }: Props) => {
  'use memo'

  const { data: loadTypes } = useAllLoadTypes()

  return (
    <FormField
      control={control}
      name={'load_type_id'}
      render={({ field }) => (
        <FormItem className={cn('shrink-0 grow', className)}>
          <FormLabel className={'text-card-foreground'}>Vehicle type</FormLabel>
          <FormControl>
            <Select
              onValueChange={value => field.onChange(z.coerce.number().optional().parse(value))}
              value={field.value?.toString()}
            >
              <SelectTrigger className={'h-[42px]'}>
                <SelectValue />
              </SelectTrigger>
              <SelectContent className={'z-[1600]'}>
                {loadTypes?.map((loadType, index) => (
                  <TrailerTypeGroup key={index} loadType={loadType} />
                ))}
              </SelectContent>
            </Select>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}

const TrailerTypeGroup = ({ loadType }: { loadType: ISubLoadType }) => {
  const [hide, setHide] = useState(loadType.hiddenDefault ?? false)

  return (
    <SelectGroup>
      {loadType?.label && (
        <SelectLabel
          className={'flex justify-between gap-2 hover:bg-accent focus:bg-accent'}
          onClick={() => {
            setHide(!hide)
          }}
        >
          {loadType.label}
          {hide ? <ChevronUp /> : <ChevronDown />}
        </SelectLabel>
      )}
      {loadType.options?.map(option => (
        <SelectItem className={cn(hide && 'hidden')} key={option.id} value={option.id.toString()}>
          {option.title}
        </SelectItem>
      ))}
    </SelectGroup>
  )
}
